// @flow
'use strict';

import * as React from 'react';

import type { IInformacoesComercioExterior } from '../types';

import RowDetalhes from '../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../common/detalhes_documento/column_detalhes';

type InformacoesComercioExteriorProps = {
  informacoesComercioExterior : IInformacoesComercioExterior,
};

export default function InformacoesComercioExterior({ informacoesComercioExterior } : InformacoesComercioExteriorProps) {
  return (
    <>
      <h3>Informações de Comércio Exterior</h3>
      <RowDetalhes data={ informacoesComercioExterior }>
        <ColumnDetalhes field="siglaUFSaidaPais">Sigla da UF de Embarque ou de transposição de fronteira</ColumnDetalhes>
      </RowDetalhes>
      <RowDetalhes data={ informacoesComercioExterior }>
        <ColumnDetalhes field="descricaoLocalExportacao">Descrição do Local de Embarque ou de transposição de fronteira</ColumnDetalhes>
      </RowDetalhes>
      <RowDetalhes data={ informacoesComercioExterior }>
        <ColumnDetalhes field="descricaoLocalDespacho">Descrição do local de despacho</ColumnDetalhes>
      </RowDetalhes>
    </>
  );
}
